import {FormProvider, UseFormReturn} from "react-hook-form";

import {Button} from "@/components/button/Button.tsx";
import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {PhoneField} from "@/components/form/fields/PhoneField.tsx";
import {Input} from "@/components/input/Input.tsx";
import {TAB_LABELS} from "@/lib/constants/subscribeDropdown";
import {SubscriptionType} from "@/lib/types/statuspages";
import styles from "./SubscribeDropdown.module.scss";
import {SubscribeFormValues} from "./SubscribeDropdown.types";

export interface SubscribeFormContentProps {
  methods: UseFormReturn<SubscribeFormValues>;
  onSubmit: (values: SubscribeFormValues) => Promise<void>;
  activeType: SubscriptionType;
  resolvedRssUrl: string | null;
  serverError: string | null;
  loading: boolean;
  copied: boolean;
}

export const SubscribeFormContent = ({
  methods,
  onSubmit,
  activeType,
  resolvedRssUrl,
  serverError,
  loading,
  copied,
}: SubscribeFormContentProps) => (
  <FormProvider {...methods}>
    <form id="subscribe-dropdown-form" onSubmit={methods.handleSubmit(onSubmit)} noValidate>
      <div className={styles.formContent}>
        <p className={styles.tabTitle}>Subscribe via {TAB_LABELS[activeType]}</p>

        {activeType === SubscriptionType.EMAIL && (
          <InputField
            name="target"
            type="email"
            placeholder="user@uptime.com"
            autoFocus
            input={<Input type="email" {...methods.register("target")} placeholder="user@uptime.com" autoFocus />}
          />
        )}

        {activeType === SubscriptionType.SMS && <PhoneField name="target" />}

        {activeType === SubscriptionType.RSS && (
          <div className={styles.fieldGroup}>
            <p className={styles.rssLabel}>Copy the link below to Subscribe:</p>
            {resolvedRssUrl ? (
              <Input readOnly value={resolvedRssUrl} aria-label="RSS feed URL" />
            ) : (
              <p className={styles.rssLoading}>Loading RSS feed URL…</p>
            )}
          </div>
        )}

        {activeType === SubscriptionType.WEBHOOK && (
          <InputField
            name="target"
            type="url"
            label="Webhook URL to send to"
            placeholder="https://your-server.com/webhook"
            input={<Input type="url" {...methods.register("target")} placeholder="https://your-server.com/webhook" />}
          />
        )}

        {serverError && (
          <p className={styles.errorText} role="alert">
            {serverError}
          </p>
        )}

        {!(activeType === SubscriptionType.RSS && !resolvedRssUrl) && (
          <Button variant="primary" size="small" type="submit" className={styles.submitBtn} disabled={loading}>
            {activeType === SubscriptionType.EMAIL
              ? "Create"
              : activeType === SubscriptionType.RSS
                ? copied
                  ? "Copied!"
                  : "Copy Link"
                : "Subscribe"}
          </Button>
        )}
      </div>
    </form>
  </FormProvider>
);
